module.exports = __webpack_public_path__ + "static/media/8100.dbfac808.jpg";